export const iconFontAwesomeMedicalHealthPrescriptionBottleMedical = (
	<i className="fa-solid fa-prescription-bottle-medical"></i>
);
